import React from 'react'
import logo from '../../../assets/icons/whitelogo.svg'
import '../style'
import { EnvelopeSimple, MapPin, Phone, WhatsappLogo } from '@phosphor-icons/react'
import {
    StyledCompanyInfo,
    StyledFooter,
    StyledFooterContent,
    StyledFooterContentGrid,
    StyledLogo,
    StyledMailInfo,
} from '../style'

const Footer = () => {
    return (
        <StyledFooter>
            <StyledFooterContent>
                <StyledFooterContentGrid>
                    <StyledLogo
                        src={logo}
                        alt="logo"
                    />
                    <StyledMailInfo>
                        <EnvelopeSimple
                            className="footer-icon"
                            size={24}
                            color="white"
                            weight="regular"
                            style={{ marginRight: '20px' }}
                        />
                        online.educon@gmail.com
                    </StyledMailInfo>
                    {/* <StyledMailInfo>
                        <MapPin
                            size={24}
                            color="white"
                            weight="regular"
                            style={{ marginRight: '20px' }}
                        />
                        4-микрорайон, 11
                    </StyledMailInfo> */}
                    <StyledMailInfo>
                        <Phone
                            className="footer-icon"
                            size={24}
                            color="white"
                            weight="regular"
                            style={{ marginRight: '20px' }}
                        />
                        +77073081616
                    </StyledMailInfo>
                    {/* <StyledMailInfo>
                        <WhatsappLogo
                            className="footer-icon"
                            size={24}
                            color="white"
                            weight="regular"
                            style={{ marginRight: '20px' }}
                        />
                        Whatsapp-қа жазыныз
                    </StyledMailInfo> */}
                </StyledFooterContentGrid>
                <StyledCompanyInfo>
                    © ТОО EduconOnline {new Date().getFullYear()}. Барлық құқықтар қорғалған.
                </StyledCompanyInfo>
            </StyledFooterContent>
        </StyledFooter>
    )
}

export default Footer
